module.exports = __webpack_public_path__ + "static/06-c8d1380fb5588792ae61a63675d7c0a0.jpg";